export const DilutionTypeValues = {
  SERIAL_DILUTION: "SERIAL_DILUTION",
  CO_FORMULATED_DILUTION: "CO_FORMULATED_DILUTION",
  MASTERMIX: "MASTERMIX",
} as const;

// eslint-disable-next-line @typescript-eslint/no-redeclare -- intentionally naming the type the same as the variable
export type DilutionType =
  (typeof DilutionTypeValues)[keyof typeof DilutionTypeValues];
